// CommonMark won't parse emphasis whose closing delimiter is followed
// directly by a letter (`**Label:**value`), but the legacy Lexical renderer
// did — so old content relies on it. Insert the missing space.
export const fixGluedEmphasis = (markdown: string): string =>
  markdown
    .replace(/(\*\*[^*\n]*?[:.,;!?)\]}]\*\*)(?=[\p{L}\p{N}])/gu, '$1 ')
    .replace(/(__[^_\n]*?[:.,;!?)\]}]__)(?=[\p{L}\p{N}])/gu, '$1 ');
